import { render, staticRenderFns } from "./tableText.vue?vue&type=template&id=0fac19a1&scoped=true&"
import script from "./tableText.vue?vue&type=script&lang=js&"
export * from "./tableText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fac19a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/thScoreShop/thScoreAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fac19a1')) {
      api.createRecord('0fac19a1', component.options)
    } else {
      api.reload('0fac19a1', component.options)
    }
    module.hot.accept("./tableText.vue?vue&type=template&id=0fac19a1&scoped=true&", function () {
      api.rerender('0fac19a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rw/tempTable/components/tableText.vue"
export default component.exports